
<template>
    <span>
        <b-icon-sort-down v-if="currentSortProperty == sortProperty && reverse == false" />
        <b-icon-sort-up v-else-if="currentSortProperty == sortProperty && reverse == true" />
    </span>
</template>

<script>

    export default {
        name: 'SortingIcon',
		props: ['currentSortProperty', 'sortProperty', 'reverse'],
        data: function () {

            return {

            }

        },
        mounted: function () {

        },
        methods: {

        },
        computed: {
            
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
